/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitEntityAssetsIpAddressesGeoip
 */
export interface MonitEntityAssetsIpAddressesGeoip {
    /**
     * 
     * @type {string}
     * @memberof MonitEntityAssetsIpAddressesGeoip
     */
    city_name?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityAssetsIpAddressesGeoip
     */
    country_name?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityAssetsIpAddressesGeoip
     */
    country_code?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof MonitEntityAssetsIpAddressesGeoip
     */
    loc?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityAssetsIpAddressesGeoip
     */
    time_zone?: string;
}

/**
 * Check if a given object implements the MonitEntityAssetsIpAddressesGeoip interface.
 */
export function instanceOfMonitEntityAssetsIpAddressesGeoip(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityAssetsIpAddressesGeoipFromJSON(json: any): MonitEntityAssetsIpAddressesGeoip {
    return MonitEntityAssetsIpAddressesGeoipFromJSONTyped(json, false);
}

export function MonitEntityAssetsIpAddressesGeoipFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityAssetsIpAddressesGeoip {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'city_name': !exists(json, 'city_name') ? undefined : json['city_name'],
        'country_name': !exists(json, 'country_name') ? undefined : json['country_name'],
        'country_code': !exists(json, 'country_code') ? undefined : json['country_code'],
        'loc': !exists(json, 'loc') ? undefined : json['loc'],
        'time_zone': !exists(json, 'time_zone') ? undefined : json['time_zone'],
    };
}

export function MonitEntityAssetsIpAddressesGeoipToJSON(value?: MonitEntityAssetsIpAddressesGeoip | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'city_name': value.city_name,
        'country_name': value.country_name,
        'country_code': value.country_code,
        'loc': value.loc,
        'time_zone': value.time_zone,
    };
}

